export default {"src":"/_next/static/media/logo-8.5aa8fda5.svg","height":51,"width":57,"blurWidth":0,"blurHeight":0};